import { toast } from 'react-toastify';
import ConfirmToast from '../components/ConfirmToast';

export const useConfirmToast = () => {
  let activeId = null;

  const confirm = (message, onConfirm, onCancel = null, options = {}) => {
    const {
      title = 'Confirmação',
      confirmText = "Confirmar",
      cancelText = "Cancelar", 
      variant = "danger"
    } = options;

    // Evita múltiplas instâncias
    if (activeId && toast.isActive(activeId)) {
      return activeId;
    }

    // cria overlay global para bloquear o fundo
    const overlay = document.createElement('div');
    overlay.setAttribute('id', 'global-confirm-overlay');
    overlay.setAttribute('style', `position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 9998;`);
    document.body.appendChild(overlay);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const cleanup = () => {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.style.overflow = previousOverflow || '';
      activeId = null;
      document.removeEventListener('keydown', handleKeyDown, true);
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        toast.dismiss(activeId);
        if (onCancel) onCancel();
        cleanup();
      }
    };
    document.addEventListener('keydown', handleKeyDown, true);

    const toastId = toast.info(
      <ConfirmToast
        title={title}
        message={message}
        onConfirm={() => {
          toast.dismiss(toastId);
          onConfirm();
          cleanup();
        }}
        onCancel={() => {
          toast.dismiss(toastId);
          if (onCancel) onCancel();
          cleanup();
        }}
        confirmText={confirmText}
        cancelText={cancelText}
        variant={variant}
      />,
      {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        hideProgressBar: true,
        icon: false,
        position: "top-center",
        style: { 
          minWidth: '0',
          maxWidth: 'none',
          marginTop: '0',
          background: 'transparent',
          boxShadow: 'none',
          padding: 0,
          border: 'none'
        }
      }
    );

    activeId = toastId;
    return toastId;
  };

  return { confirm };
};
